import React from "react";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { LocalizedText } from "../i18n/LocalizedText.js";
const MessageSnackBar = ({ message, messageValues, mode, onClose }) => {
  const handleClickAway = (_, reason) => {
    if (reason !== "clickaway") {
      handleClose();
    }
  };
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };
  return /* @__PURE__ */ React.createElement(
    Snackbar,
    {
      open: message !== null,
      autoHideDuration: 6e3,
      onClose: handleClickAway,
      anchorOrigin: { vertical: "bottom", horizontal: "center" }
    },
    /* @__PURE__ */ React.createElement(MuiAlert, { onClose: handleClose, elevation: 6, variant: "filled", severity: mode }, message ? /* @__PURE__ */ React.createElement(LocalizedText, { label: message, labelParams: messageValues }) : /* @__PURE__ */ React.createElement(React.Fragment, null))
  );
};
export {
  MessageSnackBar
};
//# sourceMappingURL=MessageSnackBar.js.map
